var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "navbar-feeds" },
    [
      _c("TabControl", {
        ref: "tabControl",
        attrs: { tabs: _vm.tabs, "more-link": "https://t.bilibili.com/" },
        scopedSlots: _vm._u([
          {
            key: "more-link",
            fn: function () {
              return [
                _vm._v("\n      所有动态\n      "),
                _c("VIcon", { attrs: { icon: "feeds", size: 18 } }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }